import { render, staticRenderFns } from "./WineTypeForm.vue?vue&type=template&id=5c55bb20"
import script from "./WineTypeForm.vue?vue&type=script&lang=ts"
export * from "./WineTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports